module.exports = __webpack_public_path__ + "static/coach-wooden-and-me-999b9cfda274234af36970f60df7860f.jpg";